import { useI18N, useLegalCheckbox } from "@sundae/react-hooks";
import { ExternalLink, Notice } from "@sundae/ui-toolkit";
import { FC, useMemo } from "react";
import { Trans } from "react-i18next";
import { Status } from "../../../gql/generated/taste-test.sdk";
import { useTasteTestContext } from "../../../pages/TasteTestDetail/context";
import { OrderActions, useOrderContext } from "../../../stores/OrderContext";
import { percentageI18n } from "../../../utils/number-format";

const TasteTestWithdrawWarning: FC<{ withConsent?: boolean }> = ({ withConsent = false }) => {
  const { currentLocale, t } = useI18N("taste-test");
  const {
    state: {
      flowData: { orderConsent },
    },
    dispatch,
  } = useOrderContext();
  const {
    state: { tasteTest },
  } = useTasteTestContext();
  const { showErrorFlash } = useLegalCheckbox();

  const withConsentProps = useMemo(() => {
    if (!withConsent) {
      return {};
    }

    return {
      showErrorFlash,
      onConsentChange: () => {
        OrderActions.setOrderConsent({ checked: !orderConsent.checked }, dispatch);
      },
      isConsentChecked: orderConsent.checked,
      withConsent,
    };
  }, [withConsent, orderConsent.checked, showErrorFlash, dispatch]);

  return (
    <Notice
      type="warning"
      size="xs"
      title={t("detail.widget.warning.withdrawal", { context: "title" })}
      {...withConsentProps}
    >
      <Trans
        i18nKey="detail.widget.warning.withdrawal"
        context={tasteTest?.status === Status.LastCall ? "lastCall" : ""}
      >
        {tasteTest?.status === Status.LastCall ? (
          <div className="inline-block">
            By continuing, you're acknowledging that you are withdrawing all of your contributed ADA
            from this Taste Test. Since this Taste Test ends in 24 hours, a withdrawal will forfeit{" "}
            {percentageI18n(tasteTest?.parameters?.penaltyPercentage || 0, currentLocale)} of your
            ADA. Read more about it{" "}
            <ExternalLink arrow="top-right" href="" className="inline" size="xs" variant="info">
              here
            </ExternalLink>
          </div>
        ) : (
          <>
            By continuing, you're acknowledging that you are withdrawing all of your contributed ADA
            from this Taste Test.
          </>
        )}
      </Trans>
    </Notice>
  );
};

export default TasteTestWithdrawWarning;
